var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import * as Sentry from '@sentry/browser';
import { datadogLogs } from '@datadog/browser-logs';
import Error from './screens/Error';
import { getStore } from './state';
import { setError } from './state/slices/slice-error';
import { ERRORS } from './consts/errors';
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            hasError: false,
        };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function (error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error: error };
    };
    ErrorBoundary.prototype.componentDidMount = function () {
        if (process.env.SENTRY_DSN) {
            Sentry.init({
                dsn: process.env.SENTRY_DSN,
                environment: process.env.ENVIRONMENT,
                // Disable default ingrations, we don't want sentry to capture all
                // errors since link is embedded into a website
                defaultIntegrations: false,
            });
        }
    };
    ErrorBoundary.prototype.componentDidCatch = function (error) {
        datadogLogs.logger.error('Caught unexpected error in Link', {
            error: error,
            stack: error === null || error === void 0 ? void 0 : error.stack,
        });
        getStore().dispatch(setError(ERRORS.clientError));
        if (process.env.NODE_ENV !== 'development') {
            Sentry.captureException(error);
        }
    };
    ErrorBoundary.prototype.render = function () {
        if (this.state.hasError) {
            return React.createElement(Error, null);
        }
        return this.props.children;
    };
    return ErrorBoundary;
}(React.Component));
export default ErrorBoundary;
